import { render, staticRenderFns } from "./tendersLotsList.vue?vue&type=template&id=288c8be7&scoped=true&"
import script from "./tendersLotsList.vue?vue&type=script&lang=js&"
export * from "./tendersLotsList.vue?vue&type=script&lang=js&"
import style0 from "./tendersLotsList.vue?vue&type=style&index=0&id=288c8be7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c8be7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288c8be7')) {
      api.createRecord('288c8be7', component.options)
    } else {
      api.reload('288c8be7', component.options)
    }
    module.hot.accept("./tendersLotsList.vue?vue&type=template&id=288c8be7&scoped=true&", function () {
      api.rerender('288c8be7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/tendersLotsList.vue"
export default component.exports